import { render } from "./QuickLinksMenu.vue?vue&type=template&id=84e96e26"
import script from "./QuickLinksMenu.vue?vue&type=script&lang=ts"
export * from "./QuickLinksMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script